<template>
    <div class="container">
        <div class="login-box">
            <div class="login-title">管理后台登录</div>
            <a-form layout="vertical" class="login-form">
                <a-form-item label="管理密码">
                    <a-input-password v-model:value="password" placeholder="请输入管理密码" @blur="savePassword" />
                </a-form-item>
            </a-form>
        </div>
    </div>
</template>

<style lang="scss" scoped>
.container {
    width: 100vw;
    height: 100vh;
    background: linear-gradient(135deg, #1a1a2e 0%, #16213e 100%);
    display: flex;
    align-items: center;
    justify-content: center;
}

.login-box {
    width: 400px;
    padding: 40px 36px;
    background: rgba(255, 255, 255, 0.96);
    border-radius: 12px;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.15);
}

.login-title {
    font-size: 20px;
    font-weight: 600;
    color: rgba(0, 0, 0, 0.88);
    text-align: center;
    margin-bottom: 24px;
}

.login-form {
    :deep(.ant-form-item-label > label) {
        font-size: 13px;
        font-weight: 500;
        color: rgba(0, 0, 0, 0.65);
    }
}

@media screen and (max-width: 768px) {
    .login-box {
        width: 90%;
        padding: 28px 20px;
    }
}
</style>

<script>
import { defineComponent } from 'vue';
export default defineComponent({
    data() {
        return {
            password: ""
        }
    },
    methods: {
        savePassword() {
            localStorage.setItem("tokenAdmin", this.password)
        }
    }
})
</script>
